import { variables } from '@indriver/yrel';

var _textColor, _backgroundColor, _hoverAndPressedBackg, _hoverAndPressedColor, _disabledBackground, _disabledTextColor;
var preset = {
  minWidth: {
    xs: '32px',
    s: '40px',
    m: '48px',
    l: '56px'
  },
  textColor: (_textColor = {
    primary: variables['extensions-text-and-icon-onbrand'],
    secondary: variables['text-and-icon-primary'],
    tertiary: variables['text-and-icon-primary']
  }, _textColor['error-low'] = variables['extensions-text-and-icon-error'], _textColor['error-high'] = variables['text-and-icon-oncolor'], _textColor.ghost = variables['text-and-icon-primary'], _textColor['tertiary-inverse'] = variables['text-and-icon-oncolor'], _textColor),
  backgroundColor: (_backgroundColor = {
    primary: variables['background-brand'],
    secondary: variables['background-secondary'],
    tertiary: variables['background-primary']
  }, _backgroundColor['error-low'] = variables['background-secondary'], _backgroundColor['error-high'] = variables['extensions-background-error'], _backgroundColor.ghost = 'transparent', _backgroundColor['tertiary-inverse'] = variables['extensions-background-inverseprimary'], _backgroundColor),
  hoverAndPressedBackgroundColor: (_hoverAndPressedBackg = {
    primary: variables['statement-background-brandpressed'],
    secondary: variables['statement-background-secondarypressed'],
    tertiary: variables['statement-background-secondarypressed']
  }, _hoverAndPressedBackg['error-low'] = variables['statement-background-secondarypressed'], _hoverAndPressedBackg['error-high'] = variables['statement-background-errorpressed'], _hoverAndPressedBackg.ghost = 'transparent', _hoverAndPressedBackg['tertiary-inverse'] = variables['statement-background-inverseprimarypressed'], _hoverAndPressedBackg),
  hoverAndPressedColor: (_hoverAndPressedColor = {
    primary: variables['extensions-text-and-icon-onbrand'],
    secondary: variables['text-and-icon-primary'],
    tertiary: variables['text-and-icon-primary']
  }, _hoverAndPressedColor['error-low'] = variables['extensions-text-and-icon-error'], _hoverAndPressedColor['error-high'] = variables['text-and-icon-oncolor'], _hoverAndPressedColor.ghost = variables['statement-text-and-icon-primarypressed'], _hoverAndPressedColor['tertiary-inverse'] = variables['statement-text-and-icon-oncolorpressed'], _hoverAndPressedColor),
  disabledBackground: (_disabledBackground = {
    primary: variables['background-disabled'],
    secondary: variables['background-disabled'],
    tertiary: variables['background-disabled']
  }, _disabledBackground['error-low'] = variables['background-disabled'], _disabledBackground['error-high'] = variables['background-disabled'], _disabledBackground.ghost = 'transparent', _disabledBackground['tertiary-inverse'] = variables['background-disabled'], _disabledBackground),
  disabledTextColor: (_disabledTextColor = {
    primary: variables['text-and-icon-disabled'],
    secondary: variables['text-and-icon-disabled'],
    tertiary: variables['text-and-icon-disabled']
  }, _disabledTextColor['error-low'] = variables['text-and-icon-disabled'], _disabledTextColor['error-high'] = variables['text-and-icon-disabled'], _disabledTextColor.ghost = variables['text-and-icon-secondary'], _disabledTextColor['tertiary-inverse'] = variables['text-and-icon-disabled'], _disabledTextColor),
  outlineColor: variables['background-accent'],
  paddingLeftRight: {
    xs: '12px',
    s: '16px',
    m: '19px',
    l: '23px'
  },
  paddingLeftRightGhost: {
    xs: '2px',
    s: '4px',
    m: '4px',
    l: '6px'
  },
  paddingLeftRightSquare: {
    xs: '8px',
    s: '10px',
    m: '12px',
    l: '16px'
  },
  gap: {
    xs: '6px',
    s: '8px',
    m: '12px',
    l: '12px'
  },
  height: {
    xs: '32px',
    s: '40px',
    m: '48px',
    l: '56px'
  },
  heightGhost: {
    xs: '26px',
    s: '26px',
    m: '34px',
    l: '42px'
  },
  outlineBorderColor: variables['background-primary'],
  borderRadius: {
    xs: '8px',
    s: '12px',
    m: '12px',
    l: '12px'
  },
  outlineBorderRadius: {
    xs: '10px',
    s: '14px',
    m: '14px',
    l: '14px'
  },
  iconHeight: {
    xs: '16px',
    s: '20px',
    m: '24px',
    l: '24px'
  },
  fontSize: {
    xs: '14px',
    s: '16px',
    m: '18px',
    l: '20px'
  },
  fontLineHeight: {
    xs: '19px',
    s: '24px',
    m: '28px',
    l: '28px'
  },
  prefixPostfixGap: {
    xs: '6px',
    s: '8px',
    m: '12px',
    l: '12px'
  },
  prefixPostfixSize: {
    xs: '16px',
    s: '20px',
    m: '24px',
    l: '24px'
  },
  fontFamily: variables['font-family-noto'],
  badgeLeftRight: {
    xs: '-14px',
    s: '-14px',
    m: '-13px',
    l: '-10px'
  },
  badgeTop: {
    xs: '-10px',
    s: '-10px',
    m: '-7px',
    l: '-7px'
  },
  alarmLeftRight: {
    xs: '-6px',
    s: '-6px',
    m: '-6px',
    l: '-6px'
  },
  alarmTop: {
    xs: '-2px',
    s: '-2px',
    m: '-2px',
    l: '-2px'
  }
};

export { preset as default };
